import React, { useState, useContext } from 'react';
import { AuthContext } from '../../App';
import { RiMailLine, RiLockLine, RiErrorWarningLine } from 'react-icons/ri';
import styles from './login.module.css';
import logo from '../../assets/img/logo-beyaz.png';



const Login = () => {
  const [email, setEmail] = useState('admin@test.edu.tr');
  const [password, setPassword] = useState('admin123');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const { login } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await new Promise(resolve => setTimeout(resolve, 1000));

      if (email === 'admin@test.edu.tr' && password === 'admin123') {
        const mockUser = {
          id: 1,
          name: 'Admin User',
          email: 'admin@test.edu.tr',
          role: 'admin'
        };
        const mockToken = 'mock_jwt_token_' + Date.now();
        
        login(mockToken, mockUser);
      } else {
        setError('Geçersiz e-posta veya şifre');
      }
    } catch (err) {
      setError('Bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginLeft}>
        <div className={styles.loginOverlay}>
          <div className={styles.welcomeText}>
            <img src={logo} height={100} alt="Logo" className={styles.logo} />
            <h1>Hedef İzleme</h1>
            <p>Akademik performans ve hedef takip sistemi ile kurumsal başarıyı artırın</p>
          </div>
        </div>
      </div>
      
      <div className={styles.loginRight}>
        <div className={styles.loginOverlay}>
          <div className={styles.loginBox}>
            <div className={styles.loginHeader}>
              <h2>Hoş Geldiniz</h2>
              <p>Hesabınıza giriş yaparak devam edin</p>
            </div>

            <form onSubmit={handleSubmit}>
              {error && (
                <div className={styles.errorMessage}>
                  <RiErrorWarningLine size={20} />
                  {error}
                </div>
              )}
              
              <div className={styles.formGroup}>
                <label>E-posta Adresi</label>
                <div className={styles.inputWrapper}>
                  <RiMailLine className={styles.inputIcon} />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="ornek@test.edu.tr"
                    required
                  />
                </div>
              </div>

              <div className={styles.formGroup}>
                <label>Parola</label>
                <div className={styles.inputWrapper}>
                  <RiLockLine className={styles.inputIcon} />
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    required
                  />
                </div>
              </div>

              <div className={styles.formOptions}>
                <label className={styles.rememberMe}>
                  <input type="checkbox" /> Beni hatırla
                </label>
                <a href="#forgot" className={styles.forgotPassword}>
                  Parolamı unuttum
                </a>
              </div>

              <button 
                type="submit" 
                className={`${styles.loginButton} ${loading ? styles.loading : ''}`}
                disabled={loading}
              >
                {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
              </button>
            </form>

            <div className={styles.loginFooter}>
              <p>Teknik destek için: <a href="mailto:support@support.edu.tr">support@support.edu.tr</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login; 